import { useState } from 'react';
import LightingIcon from '../images/LightingIcon.svg?react';
import BannerArrowIcon from '../images/BannerArrowIcon.svg?react';
import { useMutation } from '@tanstack/react-query';
import { createOrganization } from '@/bundle/shared/components/banner/AdBanner/api';
import { CreateOrganizationPayloadType } from '@/api/v1/organization/createOrganizationApi';
import { BannerLogoutModal } from './ui/BannerLogoutModal';
import { CreateOrganizationModal } from './ui/CreateOrganizationModal';
import { Banner } from '@/components/Banner/Banner';
import { GetStartedBlock } from '../styles';

interface AdBannerType {
  isClosable?: boolean;
}

export const AdBanner = ({ isClosable = true }: AdBannerType) => {
  const [isBannerOpen, setIsBannerOpen] = useState(true);
  const [isCreateOrganizationModalOpen, setIsCreateOrganizationModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const { data, mutate, isPending } = useMutation({
    mutationKey: ['create_organization'],
    mutationFn: (values: CreateOrganizationPayloadType) => {
      return createOrganization(values);
    },
    onSuccess: async (createOrganizationResponse) => {
      if (createOrganizationResponse.error) return;

      setIsBannerOpen(false);
      setIsCreateOrganizationModalOpen(false);
      setIsLogoutModalOpen(true);
    },
  });

  const closeBanner = () => {
    setIsBannerOpen(false);
  };

  return (
    <>
      {isBannerOpen && (
        <>
          <Banner isClosable={isClosable} onClose={closeBanner} icon={<LightingIcon />}>
            Let WireVault secure your business transactions - create your organization account.
            <GetStartedBlock onClick={() => setIsCreateOrganizationModalOpen(true)}>
              Get started
              <BannerArrowIcon />
            </GetStartedBlock>
          </Banner>
        </>
      )}

      <CreateOrganizationModal
        isOpen={isCreateOrganizationModalOpen}
        apiError={data?.error}
        isLoading={isPending}
        onSubmit={mutate}
        onClose={() => setIsCreateOrganizationModalOpen(false)}
      />
      {isLogoutModalOpen && <BannerLogoutModal onClose={() => setIsLogoutModalOpen(false)} />}
    </>
  );
};
